export default __webpack_public_path__ + "static/appstore-cde30aaf794dd0ce2e85b2fc46e21e80.png";